import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
const SubjectToGrades = store => ({
  path: "subjects",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "school-onboard-setup" */ "./components"),
        import(
          /* webpackChunkName: "school-onboard-setup" */ "SubjectsSetup/modules/SubjectsModule"
        ),
        import(
          /* webpackChunkName: "school-onboard-setup" */ "SubjectGroupsAndSubjects/modules/Module"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const subjectSetupReducer = importedModule1.default;
        const reducer = importedModule2.default;
        injectReducer(store, {
          key: "subjectsSetup",
          reducer: subjectSetupReducer,
        });
        injectReducer(store, {
          key: "subjectGroupsAndSubjectsSetup",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
export default SubjectToGrades;
